module.exports = __webpack_public_path__ + "static/img/11.ae2bb1ad.gif";